// RuleItem.vue
<template>
  <div id="rules" class="item">
    <div
      class="name"
      @click="$emit('click')"
    >
      {{ $t(label) }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'RuleItem',
  props: {
    label: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped src="@/styles/_left_menu.scss">
/* you can leave this empty or add component-specific overrides */
</style>
